<script>
import Component from '~/sites/shop/pages/_'
export default {
  extends: Component,
}
</script>
